import React from 'react'
// components
import { InputLabel } from 'components/FormElements'
import Wysiwyg from 'components/FormElements/Wysiwyg'
// views
import { FormControlWrapper } from './views'
// types
import { Field } from 'redux-form'
import { Editor } from '@tiptap/react'
import { Validators } from 'utils/validators'
import { ToolbarOption } from 'components/FormElements/Wysiwyg/types'
import { WrappedFieldProps } from 'redux-form/lib/Field'

interface WysiwygProps {
  toolbar?: { options?: ToolbarOption[] | readonly ToolbarOption[] }
  toolbarCustomButtons?: React.ReactNode[]
  placeholder?: string
  editorRef?: (editor: Editor | null) => void
  readOnly?: boolean
}

interface Props extends WysiwygProps {
  label?: string
  validate?: Validators
}

const renderComponent = ({ label, input, meta, ...rest }: Props & WrappedFieldProps) => {
  const fieldName = input.name

  return (
    <FormControlWrapper
      fullWidth
      margin='none'
      variant='outlined'
      focused={meta.active}
      error={meta.touched && meta.error}
      data-testid={fieldName}>
      {label && (
        <InputLabel
          shrink
          htmlFor={fieldName}
          variant='standard'
          filled={meta.active}
          focused={meta.active}
          error={meta.touched && meta.error}>
          {label}
        </InputLabel>
      )}
      <Wysiwyg {...input} {...rest} />
    </FormControlWrapper>
  )
}

const ReduxWysiwyg: React.FC<Props & { name: string }> = (props) => <Field {...props} component={renderComponent} />

export default ReduxWysiwyg
